export type RouteWatcherDelegate = (route: string) => void;
